import SplitDomainList from "./SplitDomainList";

export default SplitDomainList;
